var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('img',{attrs:{"src":require("./Img/MisionVF.jpg"),"width":"1700","height":"800"}})])
}]

export { render, staticRenderFns }